export default {
  getPromo({state, commit}, { promoId }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/promo/${promoId}`)
          .then(({data}) => {
            commit('UPDATE_PROMO', data);
            resolve(state.activePromo);
          })
          .catch(({response}) => reject(response));
    })
  },

}
